import client from './client.js';

// posOnly: true → el backend solo devuelve organizaciones con POS activo,
// así el cajero no ve tenants donde no puede operar caja.
export const lookupTenants = (email) =>
  client.post('/auth/lookup-tenants', { email, posOnly: true }).then((r) => r.data);

export const login = (email, password, tenantId) =>
  client.post('/auth/login', { email, password, tenantId }).then((r) => r.data);

// El comercio tal como está AHORA en el servidor, con su plan y lo que incluye.
//
// Solo se acepta si viene completo. A través de la caja central la respuesta
// es la del usuario que ella recuerda, y ahí el comercio puede venir como un
// simple id: eso no es un comercio que se pueda mezclar con el guardado.
export const getTenantActual = () =>
  client.get('/auth/me').then((r) => {
    const tenant = r.data?.data?.tenant_id;
    return tenant && typeof tenant === 'object' && tenant.planLimits ? tenant : null;
  });

// Ajustes del comercio que se cambian desde la caja (por ahora, si usa
// cocina). Solo un admin: el servidor lo revisa, la pantalla solo lo refleja.
// Devuelve el perfil del comercio ya guardado.
export const guardarAjusteComercio = (cambios) =>
  client.patch('/tenants/me', cambios).then((r) => r.data.data);
